<template>

<div class="row">
    <div class="flex xs12 md12 lg4">

        <va-card class="scroll">
          <p class="display-3 text-center"> {{$t('arealuno.Perguntas')}}</p>
            <hr>
          <div >
            <form @submit.prevent="addNovoChamado()">
              <div class="row">
                <div class="flex lg9 md12 xs12">
                  <va-input
                    v-model="chamado.pergunta"
                    placeholder="Pregunta "
                    :error="!!perguntaErrors.length"
                    :error-messages="perguntaErrors"
                  />
                </div>
                
                <div class="flex lg3 md2  xs12 text-center">
                    <va-button type="submit" class="text-right"   color="dark"> {{$t('arealuno.Enviar')}}</va-button>
                </div>
              </div>

          </form>
          </div>
            <div v-for="(chamado, index) in all_chamados" :key="index">

             <div class="va-item align--center no-wrap va-item--clickable" @click="mudar_chamado(chamado, index)">
               
                <div class="va-item-section va-item-section--main">
                    <div class="va-item-label ellipsis">
                        {{ chamado.nome_aluno }}
                    </div>
                    <div class="va-item-label ellipsis va-item-label--caption">
                        {{ chamado.pergunta }}
                    </div>
                </div>

                <div class="va-item-section va-item-section--side">
                    <i class="va-icon fa fa-eye" style="color: rgb(186, 191, 194);"></i>
                </div>
            </div>
                  <div>
                      <div class="va-list-separator va-list-separator--offset"></div>
                </div>
            </div>
        </va-card>

    </div>

    <div v-if="show_perguntas" class="flex xs12 md12 lg8">

        <va-card >
                     <p class="display-3 text-center"> {{$t('arealuno.Conversas')}}</p>
            <hr>
          <chatrespostas v-model="all_respostas"/>
            
        </va-card>
          
    </div>

</div>
</template>

<script>

import chatrespostas from './chatRespostas'

export default {
  name: 'forum-page',
  components: { chatrespostas },
 
  data () {
    return {
      chamado:{
        pergunta:'',
        aluno_id: this.$store.state.alunos.getAluno.id,
        oferta_data_disciplina_id: this.$store.state.datamateria.setmateria.id,
        status:1

      },
    
      chamados:'',

      perguntaErrors: [],

      toastText: 'Sucesso',
      toastDuration: 2500,
      toastIcon: 'fa-star-o',
      toastPosition: 'bottom-right',
      color: 'color="info"',

      aceito: false,

      prof : {},

      perguntas: [ ],

      show_perguntas: false,
      
    }
  },
  created(){
      this.allchamado()
    },
   
  computed: {
    all_chamados(){
      return  this.$store.state.mensagens.allchamadoaluno
    },
     all_respostas(){
     return  this.$store.state.mensagens.allrespostaschamados
    },
    isToastContentPresent () {
      return !!(this.toastText || this.toastIcon)
    },
    formReady () {
      return !this.perguntaErrors.length
    },
  },
  methods: {
    
   async allchamado(){
    
    let value ={
      id:this.$store.state.alunos.get_aluno.id,
      oferta_data_disciplina_id: this.$store.state.datamateria.setmateria.id
    }
 
     await  this.$store.dispatch('AllChamadosAlunodisciplina',value)

    },
  
    salvarResposta () {
        alert()
    },
   async addNovoChamado(){
       //console.log(this.chamado)
      this.perguntaErrors = this.chamado.pergunta ? [] : ['Pregunta']
    
      if (!this.formReady) {
        return
      }

     await  this.$store.dispatch('addChamado',this.chamado)

     this.chamado = {
        pergunta:'',
        aluno_id: this.$store.state.alunos.getAluno.id,
        oferta_data_disciplina_id: this.$store.state.datamateria.setmateria.id,
        status:1

      },

     this.allchamado()

    },

   async mudar_chamado(value){

      await  this.$store.dispatch('allRespostasChamado',value)

      this.show_perguntas = true

    },
   

  }
}
</script>

<style lang='scss'>

.scroll{
  overflow-y: scroll;
  max-height: 480px;

}
   
</style>
